import { render, staticRenderFns } from "./AppReadonlyField.vue?vue&type=template&id=ec31e044"
import script from "./AppReadonlyField.vue?vue&type=script&lang=js"
export * from "./AppReadonlyField.vue?vue&type=script&lang=js"
import style0 from "./AppReadonlyField.vue?vue&type=style&index=0&id=ec31e044&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports